<!-- Lesson Units Menu -->
@if (ready) {
  <div>
    <div class="mobile navigation-controls">
      <div style="display:flex; align-items:center; justify-content:flex-end;width:100%;">
        <div style="flex:1;text-align:left;">
          <button style="margin:8px;" (click)="displayLessonUnits = !displayLessonUnits; deferredScrollToSelected()" class="mdc-fab" aria-label="Next Page">
            <div class="mdc-fab__ripple"></div>
            <span class="mdc-fab__icon material-icons">{{displayLessonUnits ? 'menu_open' : 'menu'}}</span>
          </button>
        </div>
        <button style="margin:8px;" [ngClass]="{'disabled': !controller.priorLessonUnit}" class="mdc-fab" aria-label="Previous Page" (click)="previousLessonUnit()">
          <div class="mdc-fab__ripple"></div>
          <span class="mdc-fab__icon material-icons">skip_previous</span>
        </button>
        <button style="margin:8px;" [ngClass]="{'disabled': !controller.upcomingLessonUnit}" class="mdc-fab" aria-label="Next Page" (click)="nextLessonUnit()">
          <div class="mdc-fab__ripple"></div>
          <span class="mdc-fab__icon material-icons">skip_next</span>
        </button>
      </div>
    </div>
    <div class="lesson-units animateDefault" [ngClass]="{'open': displayLessonUnits}" [style.top]="displayJumpToSection() ? '113px' : '65px'">
      @if (displayJumpToSection()) {
        <div class="sectionList animateDefault" style="display: flex; color: #fff; flex-direction: row; width: 100%; align-items: center; justify-content: flex-start; text-align: left; z-index: 9999; position: fixed; background-color: #020c15;">
          <span style="position: absolute; padding-left: 16px;">Jump to Section</span>
          <i tabindex="1" class="material-icons mdc-top-app-bar__action-item mdc-icon-button" style="flex:1;text-align:right;" aria-label="Select Playlist">expand_circle_down</i>
          <ul class="mdc-list" style="max-height:50vh;overflow:auto; position:absolute;top:64px;background-color:#f9f9f9;">
            @for (section of controller.playlist.sections; track section; let index = $index) {
              <li
                [attr.key]="section"
                (click)="controller.navigate(index, 0, 0, 0); scrollToSelected()"
                [ngClass]="{'mdc-list-item--selected': index === controller.sectionIndex}"
                class="mdc-list-item"
                tabindex="-1">
                <span class="mdc-list-item__ripple"></span>
                <span class="mdc-list-item__text">{{section.title}}</span>
              </li>
            }
          </ul>
        </div>
      }
      @for (unit of controller.lessonUnits; track unit) {
        <div
          [attr.key]="unit"
          [attr.id]="unit.lessonUnit.id"
          [ngClass]="{'selected': unit.lessonUnit.id === controller.lessonUnit.id}"
          (click)="controller.navigate(unit.sectionIndex, unit.lessonIndex, unit.lessonUnitIndex, 0)"
          style="position:relative;padding-bottom:0px;display:flex;">
          @if (unit.primaryAsset) {
            <div>
              <img style="width:100%;height:100%; cursor:pointer;" [src]="parseSsl(unit.lessonUnitThumbnailUrl)">
              <div class="animateDefault trainingElementOverlay" style="text-align:left;flex-direction:column !important; align-items:flex-start; justify-content:flex-end;">
                <div class="trainingElementDescription animateDefault">
                  <div style="padding:8px;">
                    <div style="display:flex;flex-direction:column; align-items:start; justify-content:flex-end; flex:1;">
                      <h3 class="clip" style="margin:0px; font-size:.75em;">{{unit.section.title}}</h3>
                      <h3 class="clip" style="margin:0px; font-size:.75em;">{{unit.lesson.title}}</h3>
                      <h1 class="clip" style="margin:0px; font-size:1.5em;">{{unit.lessonUnit.title}}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <!-- App Content -->
    <div class="main-content animateDefault" [ngClass]="{'open': displayLessonUnits}">
      <div class="container" style="background-color:rgb(25,118,210);"></div>
      <div class="overlay"></div>
      <div class="overlay" style="background: linear-gradient(to left, rgba(0,0,0,1) 0%,rgba(0,0,0,0) 100%)"></div>
      @if (ready && controller.trainingElement) {
        <div class="content">
          <!-- Selected Training Element -->
          <div class="trainingElement gradient animateDefault" style="width:100%;margin-bottom:65px;">
            <div class="stage" style="display:flex;flex-direction:row;justify-content:center;width:100%;">
              @if (!playState && controller.trainingElement.type === 1) {
                <div (click)="play()" class="hide-mobile animateDefault material-icons" style="position:absolute;z-index:1;color:#fff;font-size:10vw;top:calc(50% - 5vw);cursor:pointer;">
                  play_circle_filled
                </div>
              }
              <div id="training-element">
                <!-- Video Player -->
                @if (controller.trainingElement.type === 1) {
                  <video class="animateDefault"
                    disablePictureInPicture
                    crossorigin="anonymous"
                    [ngClass]="{'paused': !playState}"
                    (playing)="playState = true; setVideoFullScreenState(); setClosedCaptions();"
                    (pause)="playState = false"
                    id="videoPlayer"
                    oncontextmenu="return false;"
                    (ended)="onVideoEnd()"
                    [autoplay]="autoPlay || playState"
                    controlslist="nodownload"
                    style="border-radius:8px; height:calc(100vh - 200px); max-width:calc(100% - 120px);outline:none;cursor:pointer;background-color:rgba(0,0,0,.75);"
                    controls
                    [src]="getVideoUrl()">
                    <track id="captions_en" kind="captions" label="english" srclang="eng">
                    <track id="captions_es" kind="captions" label="spanish" srclang="es">
                  </video>
                }
                <!-- Image Viewer -->
                @if (controller.trainingElement.type === 2) {
                  <img class="image-viewer animateDefault"
                    style="border-radius:8px;  max-height:calc(100vh - 200px); max-width:calc(100% - 120px);"
                    [src]="controller.trainingElement.data.assets[0].url"/>
                }
              </div>
            </div>
          </div>
          <div class="bottom-navigation animateDefault" [ngClass]="{'display': lessonUnitTransition}">
            <div class="left-column">
              <div class="lesson-unit-details animateDefault">
                <h3 class="clip" style="margin:0;">{{controller.section.title}}</h3>
                <h3 class="clip" style="margin:0;">{{controller.lesson.title}}</h3>
                <h1 class="clip" style="margin:0; font-size:3em;">{{controller.lessonUnit.title}}</h1>
              </div>
              <div class="lesson-unit-assets animateDefault">
                <div class="mdc-chip-set" role="grid">
                  @for (asset of controller.lessonUnit.trainingElements; track asset; let index = $index) {
                    <div class="mdc-chip"
                      [ngClass]="{'selected': index === controller.trainingElementIndex}"
                      role="row"
                      (click)="controller.navigate(controller.sectionIndex, controller.lessonIndex, controller.lessonUnitIndex, index)"
                      style="margin:8px;"
                      [attr.key]="asset">
                      <div class="mdc-chip__ripple"></div>
                      <i class="material-icons mdc-chip__icon mdc-chip__icon--leading mdc-chip__icon--leading">
                        {{asset.type === 1 ? 'ondemand_video' : 'fact_check'}}
                      </i>
                      <span role="gridcell">
                        <span role="button" tabindex="0" class="mdc-chip__primary-action">
                          <span class="mdc-chip__text">{{asset.title || 'Title'}}</span>
                        </span>
                      </span>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="right-column">
              @if (controller.upcomingLessonUnit) {
                <div class="up-next animateDefault">
                  <div style="padding-top:8px; margin:8px 12px;">
                    <div style="cursor:pointer;display:flex;flex-direction:column; align-items:flex-end; justify-content:flex-start; flex:1;" (click)="nextLessonUnit()">
                      <h3 class="clip" style="margin:0px -8px 8px 0px;padding:0px;display:flex;align-items:center;justify-content:flex-end;">Up Next <span class="material-icons">navigate_next</span></h3>
                      <h3 class="clip" style="margin:0px;font-size:.75em;">{{controller.upcomingLessonUnit.section.title}}</h3>
                      <h3 class="clip" style="margin:0px;font-size:.75em;">{{controller.upcomingLessonUnit.lesson.title}}</h3>
                      <h3 class="clip" style="margin:0px;font-size:.75em;">{{controller.upcomingLessonUnit.lessonUnit.title}}</h3>
                    </div>
                  </div>
                  <div style="margin-top:20px;" (click)="nextLessonUnit()">
                    <img style="max-height:70px; min-height:70px; margin:0 10px; border-radius:8px; cursor:pointer;" [src]="parseSsl(controller.upcomingLessonUnit.lessonUnitThumbnailUrl)">
                  </div>
                </div>
              }
              <div class="navigation-controls">
                <div style="display:flex; align-items:center; justify-content:flex-end;width:100%;">
                  <button style="margin:8px;" (click)="displayLessonUnits = !displayLessonUnits; deferredScrollToSelected()" class="mdc-fab" aria-label="Next Page">
                    <div class="mdc-fab__ripple"></div>
                    <span class="mdc-fab__icon material-icons">{{displayLessonUnits ? 'menu_open' : 'menu'}}</span>
                  </button>
                  <button style="margin:8px;" [ngClass]="{'disabled': !controller.priorLessonUnit}" class="mdc-fab" aria-label="Previous Page" (click)="previousLessonUnit()">
                    <div class="mdc-fab__ripple"></div>
                    <span class="mdc-fab__icon material-icons">skip_previous</span>
                  </button>
                  <button style="margin:8px;" [ngClass]="{'disabled': !controller.upcomingLessonUnit}" class="mdc-fab" aria-label="Next Page" (click)="nextLessonUnit()">
                    <div class="mdc-fab__ripple"></div>
                    <span class="mdc-fab__icon material-icons">skip_next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="mobile-navigation">
            <div class="lesson-unit-details animateDefault">
              <h3 class="clip" style="margin:0;">{{controller.section.title}}</h3>
              <h3 class="clip" style="margin:0;">{{controller.lesson.title}}</h3>
              <h1 class="clip" style="margin:0; font-size:3em;">{{controller.lessonUnit.title}}</h1>
            </div>
            <div class="lesson-unit-assets animateDefault">
              <div class="mdc-chip-set" role="grid">
                @for (asset of controller.lessonUnit.trainingElements; track asset; let index = $index) {
                  <div class="mdc-chip"
                    [ngClass]="{'selected': index === controller.trainingElementIndex}"
                    role="row"
                    (click)="controller.navigate(controller.sectionIndex, controller.lessonIndex, controller.lessonUnitIndex, index)"
                    style="padding:8px;"
                    [attr.key]="asset">
                    <div class="mdc-chip__ripple"></div>
                    <i class="material-icons mdc-chip__icon mdc-chip__icon--leading mdc-chip__icon--leading">
                      {{asset.type === 1 ? 'ondemand_video' : 'fact_check'}}
                    </i>
                    <span role="gridcell">
                      <span role="button" tabindex="0" class="mdc-chip__primary-action">
                        <span class="mdc-chip__text">{{asset.title || 'Title'}}</span>
                      </span>
                    </span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}